import React from "react";

import { Helmet } from "react-helmet";
import { Redirect } from "react-router-dom";

import { AuthCard } from "features/Auth/components/AuthCard";
import { useSignUpState } from "features/Auth/hooks/useSignUpState";
import { Actions, Root, TextLink } from "features/Auth/styles";
import {
    Button,
    LabeledField,
    NotificationSnackbar,
    PhoneInput,
    TextInput,
} from "shared/ui";

export const SignUp = () => {
    const state = useSignUpState();

    // Форма регистрации залогиненному не нужна — уводим в кабинет.
    if (state.isAuthorized) {
        return <Redirect to="/" />;
    }

    return (
        <Root>
            <Helmet title="Регистрация" />

            <AuthCard subtitle="Создание аккаунта">
                <LabeledField label="Телефон" htmlFor="phone">
                    <PhoneInput
                        autoFocus
                        id="phone"
                        value={state.phone}
                        disabled={state.submitting}
                        onChange={state.setPhone}
                    />
                </LabeledField>

                <LabeledField
                    label="Пароль"
                    hint={state.isPasswordTooShort ? "Минимум 4 символа" : undefined}
                    hintTone="danger"
                >
                    <TextInput
                        type="password"
                        value={state.password}
                        disabled={state.submitting}
                        onChange={state.setPassword}
                    />
                </LabeledField>

                <LabeledField
                    label="Подтвердите пароль"
                    hint={state.isConfirmationMismatched ? "Пароли не совпадают" : undefined}
                    hintTone="danger"
                >
                    <TextInput
                        type="password"
                        value={state.passwordConfirmation}
                        disabled={state.submitting}
                        onChange={state.setPasswordConfirmation}
                    />
                </LabeledField>

                <Actions>
                    <Button fullWidth disabled={!state.canSubmit} onClick={state.submit}>
                        Зарегистрироваться
                    </Button>

                    <TextLink to="/auth/sign-in">Уже есть аккаунт</TextLink>
                </Actions>
            </AuthCard>

            <NotificationSnackbar {...state.notify.snackbarProps} />
        </Root>
    );
};
